
import { defineComponent } from "vue";
import { mapGetters } from "vuex";
import ArrowUpIcon from "@/components/icons/ArrowUpIcon.vue";
import Cookies from "js-cookie";

interface AdditionalInfoData {
  isHidden: Boolean;
}

export default defineComponent({
  mounted() {
    const isHiddenFromCookie = Cookies.get("isAdditionalInfoHidden");
    this.isHidden = !!isHiddenFromCookie;
  },
  data(): AdditionalInfoData {
    return {
      isHidden: false,
    };
  },
  methods: {
    hide() {
      this.isHidden = true;
      Cookies.set("isAdditionalInfoHidden", "true");
    },
  },
  components: { ArrowUpIcon },
  computed: {
    ...mapGetters(["getPhoneNumber"]),
  },
});
